// Centralized asset URLs (provided by user)
export const ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_employment-law-firm/artifacts/naygm2jl_image.png',
  hero: 'https://customer-assets.emergentagent.com/job_employment-law-firm/artifacts/ilzggb8g_IMAGE%20VALTHELIS.jpg',
  team: {
    laurence: '/team/laurence.jpg',
    ageron: '/team/ageron.jpg',
    caroline: '/team/caroline.png',
  },
};

export const FIRM_INFO = {
  name: 'Cabinet VALTHELIS Avocats',
  shortName: 'VALTHELIS',
  address: "5 Place de l'Abbé Boursier, 69370 Saint Didier au Mont d'Or",
  phone: '+33 (0)9 78 81 35 97',
  phoneLink: '+33978813597',
  emails: {
    secretariat: 'secretariat1@valthelis-avocats.com',
    laurence: 'verdier@valthelis-avocats.com',
    ageron: 'ageron@valthelis-avocats.com',
    caroline: 'billotet@valthelis-avocats.com',
  },
  mapsEmbedUrl:
    "https://maps.google.com/maps?q=5%20Place%20de%20l'Abb%C3%A9%20Boursier%2069370%20Saint%20Didier%20au%20Mont%20d'Or&t=&z=16&ie=UTF8&iwloc=&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=5+Place+de+l%27Abb%C3%A9+Boursier+69370+Saint+Didier+au+Mont+d%27Or",
};
